import { render, staticRenderFns } from "./MarkBookAssesment.vue?vue&type=template&id=6e17367a"
import script from "./MarkBookAssesment.vue?vue&type=script&lang=js"
export * from "./MarkBookAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports